import React from 'react';
import { bool, shape, string } from 'prop-types';

const GroupFolder = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 8.25V2.25H11.25V4.5H6.75V2.25H1.5V8.25H6.75V6H8.25V13.5H11.25V15.75H16.5V9.75H11.25V12H9.75V6H11.25V8.25H16.5ZM5.25 6.75H3V3.75H5.25V6.75ZM12.75 11.25H15V14.25H12.75V11.25ZM12.75 3.75H15V6.75H12.75V3.75Z" fill="currentColor" />
  </svg>
);

GroupFolder.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default GroupFolder;
